import { useState } from "react";
import axios from "axios";
import Gologo from "../Images/glogo.png";

const Contact = () => {
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [showPrivacyError, setShowPrivacyError] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [submittedData, setSubmittedData] = useState(null);
  const [formData, setFormData] = useState({
    User_Name: "",
    Selected_Service: "",
    Mobile_Number: "",
    Email: "",
    Address: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.User_Name.trim()) {
      newErrors.User_Name = "Full name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.User_Name)) {
      newErrors.User_Name = "Name can only contain letters and spaces";
    }

    if (!formData.Mobile_Number.trim()) {
      newErrors.Mobile_Number = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.Mobile_Number)) {
      newErrors.Mobile_Number = "Phone number must be exactly 10 digits";
    }

    if (!privacyChecked) {
      setShowPrivacyError(true);
    } else {
      setShowPrivacyError(false);
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0 && privacyChecked) {
      try {
        const response = await axios.post(
          "https://rmsl.geecomindia.in:8087/api/contactforlandingpage",
          formData
        );
        console.log("Submitted:", response.data);
        setShowSuccessModal(true);

        // ✅ Clear form after submission
        setFormData({
          User_Name: "",
          Selected_Service: "",
          Mobile_Number: "",
          Email: "",
          Address: "",
        });
        setPrivacyChecked(false);
      } catch (error) {
        alert("Submission failed. Please try again.");
        console.error("Error submitting form:", error);
      }
    }
  };

  return (
    <section id="contact" className="py-10 bg-gray-50 mt-10">
      <div className="container mx-auto px-4" id="el-vga8ngfb">
        {/* Section Header */}
        <div
          className="text-center mb-16"
          id="el-d7la66k5"
          data-aos="fade-up" // <-- Add your desired animation type here
        >
          <p
            className="text-2xl font-bold text-black-600 mx-auto"
            id="el-asrry39g"
            data-aos="zoom-in" // <-- Optional: Add AOS to this element as well
          >
            Get in touch with our team to learn how we can help your business go
            digital with a GeeQR
          </p>
        </div>

        <div className="max-w-6xl mx-auto" id="el-smyyjucz">
          <div
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16"
            id="el-2l5pw0nv"
          >
            {/* Contact Form */}
            <div
              className="bg-white rounded-2xl shadow-sm p-8 md:p-10"
              id="el-rlfvkbfl"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <h3
                className="text-2xl font-bold text-gray-900 mb-6"
                id="el-8nxe4ybn"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                Send Us a Message
              </h3>

              <form
                onSubmit={handleSubmit}
                className="space-y-6"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div
                  className="grid grid-cols-1 md:grid-cols-2 gap-6"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  {/* Name */}
                  <div data-aos="fade-right" data-aos-delay="400">
                    <label
                      htmlFor="User_Name"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Full Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="User_Name"
                      name="User_Name"
                      value={formData.User_Name}
                      onChange={(e) =>
                        setFormData({ ...formData, User_Name: e.target.value })
                      }
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter your name"
                    />
                    {errors.User_Name && (
                      <p className="text-red-500 text-sm">{errors.User_Name}</p>
                    )}
                  </div>

                  {/* Email */}
                  <div data-aos="fade-left" data-aos-delay="500">
                    <label
                      htmlFor="Email"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="Email"
                      name="Email"
                      value={formData.Email}
                      onChange={(e) =>
                        setFormData({ ...formData, Email: e.target.value })
                      }
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter your email"
                    />
                    {errors.Email && (
                      <p className="text-red-500 text-sm">{errors.Email}</p>
                    )}
                  </div>
                </div>

                {/* Phone */}
                <div data-aos="fade-up" data-aos-delay="600">
                  <label
                    htmlFor="Mobile_Number"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Phone Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="tel"
                    id="Mobile_Number"
                    name="Mobile_Number"
                    value={formData.Mobile_Number}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        Mobile_Number: e.target.value,
                      })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your phone number"
                  />
                  {errors.Mobile_Number && (
                    <p className="text-red-500 text-sm">
                      {errors.Mobile_Number}
                    </p>
                  )}
                </div>

                {/* Address */}
                <div data-aos="fade-up" data-aos-delay="700">
                  <label
                    htmlFor="Address"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Address
                  </label>
                  <textarea
                    id="Address"
                    name="Address"
                    rows="3"
                    value={formData.Address}
                    onChange={(e) =>
                      setFormData({ ...formData, Address: e.target.value })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your address"
                  />
                </div>

                {/* Selected_Service */}
                <div data-aos="fade-up" data-aos-delay="800">
                  <label
                    htmlFor="Selected_Service"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    I'm Interested In
                  </label>
                  <select
                    id="Selected_Service"
                    name="Selected_Service"
                    value={formData.Selected_Service}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        Selected_Service: e.target.value,
                      })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="" disabled>
                      Intrested In
                    </option>
                    <option value="digital-identity">
                      QR-Based Digital Identity
                    </option>
                    <option value="retail-management">
                      QR-Based Retail Business - Viral Effect
                    </option>
                    <option value="marketing-management">
                      QR-Based Marketing - Viral Effect
                    </option>
                    <option value="demand-management">
                      QR-Based Demand Consolidation
                    </option>
                    <option value="agriculture-solutions">
                      Agriculture Solutions
                    </option>
                    <option value="agriculture-rural-digitization">
                      Agri-Rural Digitization
                    </option>
                    <option value="digital-documentation">
                      Digital Documentation with Traceability
                    </option>
                    <option value="survey">Survey with Traceability</option>
                    <option value="agri-rural-product">
                      Agri-Rural Product Marketing - Viral Effect
                    </option>
                    <option value="handicrafts">
                      Handicraft-Artisanal Product Marketing - Viral Effect
                    </option>
                    <option value="process-workflow">
                      Process-Workflow Automation
                    </option>
                    <option value="custom-solutions">
                      Custom Digital Solutions
                    </option>
                  </select>
                </div>

                {/* Privacy checkbox */}
                <div
                  className="flex items-center"
                  data-aos="fade-up"
                  data-aos-delay="900"
                >
                  <input
                    type="checkbox"
                    id="privacy-policy"
                    name="privacy-policy"
                    checked={privacyChecked}
                    onChange={(e) => {
                      setPrivacyChecked(e.target.checked);
                      if (e.target.checked) setShowPrivacyError(false);
                    }}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label
                    htmlFor="privacy-policy"
                    className="ml-2 block text-sm text-gray-700"
                  >
                    I agree to the{" "}
                    <span
                      className="text-blue-600 hover:underline cursor-pointer"
                      onClick={() => setShowPrivacyModal(true)}
                    >
                      Privacy Policy
                    </span>
                  </label>
                </div>
                {showPrivacyError && (
                  <p className="text-red-500 text-sm mt-1">
                    You must agree to the privacy policy to proceed.
                  </p>
                )}

                {/* Submit */}
                <div
                  className="mt-4"
                  data-aos="zoom-in-up"
                  data-aos-delay="1000"
                >
                  <button
                    type="submit"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-300"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
            {/* Contact Information */}
            <div
              className="flex flex-col justify-between"
              id="el-vsu64vyg"
              data-aos="fade-up"
            >
              <div id="el-93zwvgrl">
                <h3
                  className="text-2xl font-bold text-gray-900 mb-6"
                  id="el-d3w7dqjn"
                  data-aos="fade-down"
                >
                  Get in Touch
                </h3>

                {/* <!-- Uncommented image section --> */}
                {/* <!-- <img
      src="https://images.unsplash.com/photo-1591655694472-cc751117d95f?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w2MzQ2fDB8MXxzZWFyY2h8MXx8ZW1wb3BlYmluZyUyNTIwZmFybWVycyUyNTJDJTI1MjBmcG9zJTI1MkMlMjUyMHJ1cmFsJTI1MjBlbnRyZXByZW5ldXJzJTI1MjB0aHJvdWdoJTI1MjBmcnVnYWwlMjUyMHNpbXBsZSUyNTIwZGlnaXRhbCUyNTIwc29sdXRpb25zLiUyNTIwcmV0YWlsJTI1MjBtYXJrZXRpbmclMjUyMHNpbXBsaWZpZWQlMjUyMHRlY2hub2xvZ3kuJTI1MjBjb250YWN0JTI1MjBsb2NhdGlvbiUyNTIwcHJvZmVzc2lvbmFsJTI1MjB3ZWxjb21pbmd8ZW58MXwwfHx8MTc0NTIxNTM4OXww"
      alt="Woman smiling, representing welcoming customer support"
      onError={(e) => {
        e.currentTarget.src =
          "https://placehold.co/800x400?text=Contact+Us";
        e.currentTarget.classList.add("object-contain", "p-4");
      }}
      className="w-full h-auto rounded-lg object-cover mb-8"
      width="5834"
      height="3959"
      id="el-co4rzxt4"
    /> --> */}

                <div className="mt-8 space-y-6" id="el-6g6ilt2e">
                  {/* <!-- Phone --> */}
                  <div
                    className="flex items-start"
                    id="el-na9bhiu0"
                    data-aos="fade-right"
                  >
                    <div
                      className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center mr-4"
                      id="el-qz59zutu"
                    >
                      <svg
                        className="h-5 w-5 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        id="el-wrq5fgu6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                    </div>
                    <div id="el-azefqoha">
                      <h4
                        className="text-lg font-medium text-gray-900"
                        id="el-59rx7o0v"
                      >
                        Phone
                      </h4>
                      <a
                        href="tel:+919876543210"
                        className="text-gray-600 hover:text-blue-600 transition-colors"
                        id="el-xeegouhj"
                      >
                        +91 9140756963, +91 7724990078, <br /> +91 6232497321,
                        +91 6264579713, +91 7259931071
                      </a>
                    </div>
                  </div>

                  {/* <!-- Email --> */}
                  <div
                    className="flex items-start"
                    id="el-lj4hoouk"
                    data-aos="fade-left"
                  >
                    <div
                      className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center mr-4"
                      id="el-xdbmj0bj"
                    >
                      <svg
                        className="h-5 w-5 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        id="el-d0p0c3q4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div id="el-pck5ngv7">
                      <h4
                        className="text-lg font-medium text-gray-900"
                        id="el-pzqfuk43"
                      >
                        Email
                      </h4>
                      <a
                        href="mailto:info@geecomindia.in"
                        className="text-gray-600 hover:text-blue-600 transition-colors"
                        id="el-1sr08wqg"
                      >
                        contact@geecomindia.in
                      </a>
                    </div>
                  </div>

                  {/* <!-- Address --> */}
                  <div
                    className="flex items-start"
                    id="el-67yzaysn"
                    data-aos="fade-up"
                  >
                    <div
                      className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center mr-4"
                      id="el-yr7kaq4y"
                    >
                      <svg
                        className="h-5 w-5 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        id="el-3q01mhdk"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                    <div id="el-2q24xzze">
                      <h4
                        className="text-lg font-medium text-gray-900"
                        id="el-d9p9mlbj"
                      >
                        Office Location
                      </h4>
                      <address
                        className="text-gray-600 not-italic"
                        id="el-x2s8j6zd"
                      >
                        786-787, Scheme No 114 Part-2, Satya Sai Nagar, Indore,
                        <br />
                        Madhya Pradesh, India - 452010
                      </address>
                    </div>
                  </div>

                  {/* <!-- Working Hours --> */}
                  <div className="mt-12" id="el-n7b7mpze" data-aos="fade-up">
                    <div
                      className="bg-blue-50 rounded-lg p-6 mb-8"
                      id="el-2jizy1zo"
                    >
                      <h4
                        className="text-lg font-medium text-gray-900 mb-3"
                        id="el-7roxxplb"
                      >
                        Working Hours
                      </h4>
                      <ul className="space-y-2 text-gray-600" id="el-4m7jyi04">
                        <li className="flex justify-between" id="el-4k3ei6h0">
                          <span id="el-qz90gc23">Monday - Saturday:</span>
                          <span id="el-jox024ll">9:30 AM - 6:30 PM</span>
                        </li>
                        <li className="flex justify-between" id="el-28an4qa3">
                          <span id="el-6vynpnef">Sunday:</span>
                          <span id="el-a9tmvfxd">Closed</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* <!-- Connect With Us --> */}
                  {/* Connect With Us */}
                  <div id="el-1mo4g61n">
                    <h4
                      className="text-lg font-medium text-gray-900 mb-3"
                      id="el-hfmg0vu7"
                    >
                      Connect With Us
                    </h4>
                    <div className="flex space-x-4" id="el-4as0ipud">
                      <a
                        href="https://www.facebook.com/profile.php?id=100093565099831"
                        className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center hover:bg-blue-200 transition-colors"
                        aria-label="Facebook"
                        id="el-m0kfba8w"
                        target="_blank"
                      >
                        <svg
                          className="h-5 w-5 text-blue-600"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          id="el-kewmujym"
                        >
                          <path
                            d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
                            id="el-v1rw1ohv"
                          />
                        </svg>
                      </a>
                      <a
                        href="https://x.com/GeecomIndia"
                        className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center hover:bg-blue-200 transition-colors"
                        aria-label="Twitter"
                        id="el-jed5rv22"
                        target="_blank"
                      >
                        <svg
                          className="h-5 w-5 text-blue-600"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          id="el-ngbpkc22"
                        >
                          <path
                            d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
                            id="el-m4iwn54t"
                          />
                        </svg>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/geecom-india/"
                        className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center hover:bg-blue-200 transition-colors"
                        aria-label="LinkedIn"
                        id="el-a3cnm9h3"
                        target="_blank"
                      >
                        <svg
                          className="h-5 w-5 text-blue-600"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          id="el-dzmd3p2k"
                        >
                          <path
                            d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"
                            id="el-d8wlsvur"
                          />
                        </svg>
                      </a>
                      <a
                        href="https://www.instagram.com/geecomindiaofficial/"
                        className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center hover:bg-blue-200 transition-colors"
                        aria-label="Instagram"
                        id="el-u5lp1fuv"
                        target="_blank"
                      >
                        <svg
                          className="h-5 w-5 text-blue-600"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          id="el-7658vur7"
                        >
                          <path
                            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                            id="el-tnpdqjj6"
                          />
                        </svg>
                      </a>
                      <a
                        href="https://wa.me/9140753963"
                        className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center hover:bg-blue-200 transition-colors"
                        aria-label="WhatsApp"
                        id="el-pti3jrdv"
                        target="_blank"
                      >
                        <svg
                          className="h-5 w-5 text-blue-600"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          id="el-t193eq4z"
                        >
                          <path
                            d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
                            id="el-gsglkhsb"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="mt-20 max-w-6xl mx-auto bg-white rounded-2xl shadow-sm overflow-hidden"
          id="el-8ht2wu8b"
          data-aos="fade-up" // AOS animation here
        >
          <div
            className="h-[400px] w-full bg-gray-200 relative"
            id="el-yor7ougc"
            data-aos="fade-in" // AOS animation here
          >
            {/* Placeholder for map, replace with actual map integration */}
            <div
              className="h-[400px] w-full relative"
              id="el-yor7ougc"
              data-aos="zoom-in"
            >
              {/* Embedded Google Map */}
              <a
                href="https://www.google.com/maps/place/GeeCom+India+Services+Private+Limited/@22.7649498,75.9023851,21z/data=!4m14!1m7!3m6!1s0x396302aa35000001:0x41266d3befee309f!2sGeeCom+India+Services+Private+Limited!8m2!3d22.7649603!4d75.9025408!16s%2Fg%2F11fpmk1p7k!3m5!1s0x396302aa35000001%3A0x41266d3befee309f!8m2!3d22.7649603!4d75.9025408!16s%2Fg%2F11fpmk1p7k?entry=ttu"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute inset-0 z-10"
                aria-label="View GeeCom India Services on Google Maps"
              >
                {/* Empty link to make whole map clickable */}
              </a>
              <iframe
                className="absolute inset-0 w-full h-full z-0 pointer-events-none rounded-2xl"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.271890167284!2d75.9023851!3d22.764949799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396302aa35000001%3A0x41266d3befee309f!2sGeeCom%20India%20Services%20Private%20Limited!5e0!3m2!1sen!2sin!4v1713865574871!5m2!1sen!2sin"
                loading="lazy"
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
                data-aos="fade-up"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      {/* Success Message Modal */}
      {showSuccessModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          aria-modal="true"
          role="dialog"
          data-aos="fade-in"
        >
          <div className="absolute inset-0 bg-black bg-opacity-75 transition-opacity"></div>
          <div className="relative bg-white rounded-lg max-w-md w-full mx-4 overflow-hidden shadow-xl transform transition-all">
            {/* 🟦 Logo at Top-Left */}
            <img
              src={Gologo}
              alt="Logo"
              className="absolute top-4 left-4 w-12 h-12 object-contain"
              data-aos="fade-down"
            />
            <div className="p-6 text-center pt-16">
              <svg
                className="h-16 w-16 text-green-500 mx-auto mb-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                data-aos="zoom-in"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <h3
                className="text-xl font-bold text-gray-900 mb-2"
                data-aos="fade-up"
              >
                Message Sent Successfully!
              </h3>
              <p className="text-gray-600 mb-6" data-aos="fade-in">
                Thank you for contacting us. We'll get back to you within 24
                hours.
              </p>
              <button
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
                onClick={() => setShowSuccessModal(false)}
                data-aos="fade-down"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          aria-modal="true"
          role="dialog"
          data-aos="fade-in"
        >
          <div className="absolute inset-0 bg-black bg-opacity-75 transition-opacity"></div>
          <div className="relative bg-white rounded-lg max-w-2xl w-full mx-4 overflow-hidden shadow-xl transform transition-all">
            {/* 🟦 Logo at Top-Left */}
            <img
              src={Gologo}
              alt="GeeCom Logo"
              className="w-10 h-15 object-contain ml-7 mt-4"
              data-aos="fade-left"
            />
            {/* Close button */}
            <div className="absolute top-0 right-0 pt-4 pr-4">
              <button
                className="text-gray-400 hover:text-gray-500 focus:outline-none"
                aria-label="Close modal"
                onClick={() => setShowPrivacyModal(false)}
                data-aos="fade-right"
              >
                <svg
                  className="h-6 w-6 mt-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Content Section */}
            <div className="p-6 sm:p-8 pt-20" data-aos="zoom-in-up">
              <h3
                className="text-xl font-bold text-gray-900"
                data-aos="fade-up"
              >
                Privacy Policy
              </h3>
              <div className="prose max-w-none overflow-y-auto max-h-[60vh] pr-2 text-justify">
                <p>
                  We value the trust you place in us. That’s why we insist upon
                  the highest standards for secure transactions and customer
                  information privacy. Please read this Privacy Policy carefully
                  to learn about our information gathering, dissemination
                  practices, privacy and security of your information and data.
                </p>

                <p>
                  This Privacy Policy sets out the manner in which GeeCom India
                  Private Limited, having its place of business at HIG-34, Vijay
                  Nagar, Indore MP - 452010 (hereinafter referred to as GeeCom,
                  We, Us), collects, uses, maintains and discloses information
                  collected from the users of mobile or desktop application,
                  website and/or services connected with it (hereinafter
                  referred to as You, Your, User).
                </p>

                <p>
                  This Privacy Policy sets out our commitment for protecting the
                  privacy of personal information provided to us, or otherwise
                  collected by us, offline or online, including through our
                  online platforms (Website/Apps) i.e. www.geecomindia.com,
                  www.geecomindia.in, GeeCom India App, GeeCom Delivery App,
                  it's Simple App, GIDemo App in play store.
                </p>

                <p>
                  In this document, our online platforms (www.geecomindia.com,
                  www.geecomindia.in, GeeCom India App, GeeCom Delivery App,
                  it's Simple App, GIDemo App) are also referred to as
                  ‘Website/Apps’ OR ‘Online Platforms’ for convenience.
                </p>

                <p>
                  Our privacy policy is subject to revision, alteration,
                  amendment, modification, or change at any time without notice.
                  Updated policy will be in force from the date of publication
                  on Online Platform. By updating, downloading, installing
                  and/or continuing to access/use this Platform, You agree to be
                  bound by any such alteration, amendment, addition, or
                  modification. Please review this policy periodically. By
                  visiting this Website/App, you agree to be bound by the terms
                  and conditions of this Privacy Policy. If you do not agree,
                  please do not download, use, or access our Website/App.
                </p>

                <p>
                  By merely using or registering your profile on the
                  Website/App, you expressly consent to our use, disclosure,
                  collection, transfer, storage, and other uses of your personal
                  information in accordance with this Privacy Policy. This
                  Privacy Policy is incorporated into and subject to the Terms
                  of Use.
                </p>

                <p>
                  This Privacy Policy does not apply to the practices of third
                  parties that GeeCom does not own, control, or manage including
                  but not limited to any third-party websites, services,
                  applications, or businesses (Third-Party Services). GeeCom
                  does not take responsibility for the content or privacy
                  policies of those Third-Party Services. GeeCom encourages You
                  to carefully review the privacy policies of all Third-Party
                  Services You access through the Online Platform.
                </p>

                <h4 className="font-bold mt-4">Permissions:</h4>
                <p>
                  In each and every step (wherever applicable) we ask user's
                  permission before accessing user and device information,
                  device features, device hardware, etc. (for example: Location,
                  Storage, Internet, Network, Camera, Read Contacts, Read SMS,
                  etc.). User may Allow or Deny all such permissions. Upon
                  denying access, user may not be able to use the
                  services/features/functionality requiring such access.
                </p>

                <p>
                  We do ask user's permission before accessing 'Contact list'.
                  We do not 'store', 'save', or 'use in any other way' the
                  'Contact list' Information of the user. We access 'Contact
                  list' to support/enable user-friendly feature for our users so
                  that our users can share details about their profile in GeeCom
                  India app with people in their contact list. This will help
                  them grow their business.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Contact;
